import { defineMigrations } from '@tldraw/tldraw'

export const Versions = {
  AddShadowProp: 1,
  AddStrokeProps: 2,
  AddIsEditableProp: 3,
  AddVerticalAlignProp: 4,
  AddIsAutoUpdatableProp: 5,
  AddBackgroundProps: 6,
  AddRichTextProp: 7,
} as const

export const textBoxShapeMigrations = defineMigrations({
  currentVersion: Versions.AddRichTextProp,
  migrators: {
    [Versions.AddShadowProp]: {
      up: (shape) => {
        return {
          ...shape,
          props: {
            ...shape.props,
            shadow: null,
          },
        }
      },
      down: (shape) => {
        const { shadow: _, ...props } = shape.props
        return { ...shape, props }
      },
    },
    [Versions.AddStrokeProps]: {
      up: (shape) => {
        return {
          ...shape,
          props: {
            ...shape.props,
            strokeColor: '#000000',
            strokeWidth: 0,
          },
        }
      },
      down: (shape) => {
        const { strokeColor: _, strokeWidth: __, ...props } = shape.props
        return { ...shape, props }
      },
    },
    [Versions.AddIsEditableProp]: {
      up: (shape) => {
        return { ...shape, props: { ...shape.props, isEditable: true } }
      },
      down: (shape) => {
        const { isEditable: _, ...props } = shape.props
        return { ...shape, props }
      },
    },
    [Versions.AddVerticalAlignProp]: {
      up: (shape) => {
        return {
          ...shape,
          props: {
            ...shape.props,
            verticalAlign: 'middle',
          },
        }
      },
      down: (shape) => {
        const { verticalAlign: _, ...props } = shape.props
        return { ...shape, props }
      },
    },
    [Versions.AddIsAutoUpdatableProp]: {
      up: (shape) => {
        return {
          ...shape,
          props: {
            ...shape.props,
            isAutoUpdatable: true,
          },
        }
      },
      down: (shape) => {
        const { isAutoUpdatable: _, ...props } = shape.props
        return { ...shape, props }
      },
    },
    [Versions.AddBackgroundProps]: {
      up: (shape) => {
        return {
          ...shape,
          props: {
            ...shape.props,
            backgroundFill: null,
            backgroundShape: 'silhouetteSquare',
          },
        }
      },
      down: (shape) => {
        const { backgroundFill: _, backgroundShape: __, ...props } = shape.props
        return { ...shape, props }
      },
    },
    [Versions.AddRichTextProp]: {
      up: (shape) => {
        return {
          ...shape,
          props: {
            ...shape.props,
            // Monospace-authored snapshots carry a richText doc while stamping an older schema
            // version; overwriting it here would destroy the runs on first editor load.
            richText: shape.props.richText ?? null,
          },
        }
      },
      down: (shape) => {
        const { richText: _, ...props } = shape.props
        return { ...shape, props }
      },
    },
  },
})
